import { render, staticRenderFns } from "./RetailerList.vue?vue&type=template&id=767926a8&"
import script from "./RetailerList.vue?vue&type=script&lang=js&"
export * from "./RetailerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports